import * as React from 'react';

import cx from 'classnames';
import { useDetectPrint } from 'lib/use-detect-print';

import Icon from 'components/icon/icon';
import { Header2, P2 } from 'components/typography';
import { TextProps } from 'components/typography/text';

type Props = {
  align?: 'center';
  as?: React.ElementType;

  title: string;
  contentHtml?: React.ReactNode;
  content?: string;
  icon?: 'smiley' | 'cookie';
  color?: 'black' | 'orange' | 'primary';
};

const GoodToKnow: React.FC<Props> = ({
  align,
  as = 'p',
  title,
  content,
  contentHtml,
  color = 'black',
}) => {
  const classnames = {
    block: cx({
      'good-to-know': true,
      'good-to-know--primary': color === 'primary',
      'good-to-know--orange': color === 'orange',
      'good-to-know--center': align === 'center',
    }),
  };
  const isPrinting = useDetectPrint();

  return (
    <section className={classnames.block}>
      <div className="good-to-know__inner">
        {isPrinting ? null : (
          <div className="good-to-know__icon">
            <Icon name={Icon.Name.Logo} />
          </div>
        )}
        <div className="good-to-know__title">
          <Header2 as="h2">{title}</Header2>
        </div>
        <div className="good-to-know__text">
          {contentHtml}
          {content ? <P2 html={content} as={as as TextProps['as']} /> : null}
        </div>
      </div>
    </section>
  );
};

export default GoodToKnow;
